// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1OTz7","notes":"Notes_notes__2KWtx","note":"Notes_note__3RMNc","markdown":"Notes_markdown__AtPCZ"};